export * from './Calendar'
export * from './DatePickerButton'
export * from './helpers/generateCalendarMonth'
export * from './DatePickerButton.types'
export * from './CalendarSideColum'

export const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

export const lengths = {
  day: 8640000, // 24 * 60 * 60 * 1000
  week: 8640000 * 7,
  '30 Days': 8640000 * 30
}

